import { Button } from '@travelnest/merlin.button';
import { Modal } from '@travelnest/merlin.modal';
import theme from '@travelnest/merlin.theme';
import React from 'react';
import { IEventNote, IPendingEventNote } from '../../../../../../data/entities/event/event-note';
import { FormInputTextArea, FormLabel, FormSelect } from '../../../../../components/form';
import { Paragraph } from '../../../../../components/paragraph/Paragraph';

interface ICancelBookingModalProps {
	propertyId: number | string;
	eventId: string;
	onRequestClose: () => any;
	cancelBooking: () => any;
	submitEventNotes: (propertyId: string | number, eventId: string, eventNotes: IPendingEventNote[]) => any;
}

export const CancelBookingModal: React.FC<ICancelBookingModalProps> = (props) => {
	const { propertyId, eventId, submitEventNotes, cancelBooking, onRequestClose } = props;
	const [instigator, setInstigator] = React.useState('GUEST');
	const [reason, setReason] = React.useState('IN_CANCELLATION_WINDOW');
	const [comment, setComment] = React.useState('');

	const onSave = async () => {
		const pend = {
			action: 'add',
			eventNote: {
				event_id: eventId,
				note_type: 'audit',
				content: `Booking cancellation instigator - ${instigator}${reason ? '\nReason - ' + reason : ''}${comment ? '\nComment - ' + comment : ''}`
			} as IEventNote,
			eventId
		} as IPendingEventNote;
		await submitEventNotes(propertyId, eventId, [pend]);
		await cancelBooking();
		onRequestClose();
	};

	return <Modal
		title="Cancellation request"
		shouldCloseOnOverlayClick={false}
		onRequestClose={onRequestClose}
		actionRHS={
			<Button
				id="booking_cancellation_reason_save"
				onClick={onSave}
				bgColor={theme.colours.success.default}
				color={theme.colours.text.light}
			>
				Save
			</Button>}
	>
		<div className="booking_cancellation_content">
			<Paragraph>Please select who instigated this cancellation.</Paragraph>
			<Paragraph>This will be used for internal auditing and where possible, displayed on channels.</Paragraph>
			<Paragraph>(On HomeAway, Travelnest cancellations will be displayed as owner cancellations
				and channel cancellations will be displayed as guest cancellations)</Paragraph>
			<FormLabel htmlFor="booking_cancellation--instigator">Instigator</FormLabel>
			<FormSelect id="booking_cancellation--instigator" value={instigator} onChange={(e) => setInstigator(e.target.value)}>
				<option value="GUEST">Guest</option>
				<option value="OWNER">Owner</option>
				<option value="TRAVELNEST">Travelnest</option>
				<option value="CHANNEL">Channel</option>
			</FormSelect>
			<FormLabel htmlFor="booking_cancellation--reason">Reason</FormLabel>
			<FormSelect id="booking_cancellation--reason" value={reason} onChange={(e) => setReason(e.target.value)}>
				<option value="IN_CANCELLATION_WINDOW">In Cancellation Window</option>
				<option value="NO_PAYMENT">No Payment</option>
				<option value="DOUBLE_BOOKING">Double Booking</option>
				<option value="GUEST_ERROR">Guest Error</option>
				<option value="GUEST_COMPLAINT">Guest Complaint</option>
				<option value="CHURN">Churn</option>
				<option value="LISTING_ERROR">Listing Error</option>
				<option value="FRAUD">Fraud</option>
				<option value="REJECTED_BY_OWNER">Rejected by Owner</option>
				<option value="EARLY_PAYMENT">Early Payment</option>
				<option value="CORONAVIRUS">Coronavirus</option>
				<option value="OTHER">Other</option>
			</FormSelect>
			<FormLabel htmlFor="booking_cancellation--comment">Comment</FormLabel>
			<FormInputTextArea id="booking_cancellation--comment" defaultValue={comment} onChange={(e) => setComment(e.target.value)} />
		</div>
	</Modal>;
};
